// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicePriorities_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/service_priorities/lista
 *
 * Full service-priority matrix for the current franchise filter.
 * Wire shape: `dados: ServicePriorities_PriorityRow[]` — list emitted
 * directly as `dados`, not nested under a key.
 */
import type { ServicePriorities_PriorityRow } from './ServicePriorities_PriorityRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ServicePriorities_ListaResponseDados = ServicePriorities_PriorityRow[];

export type ServicePriorities_ListaResponse = ApiResponse<ServicePriorities_ListaResponseDados>;

registerResponseContract('ServicePriorities_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_service_priority_id:            { type: 'number',  required: true },
      so_service_priority_service_id:    { type: 'number',  required: false },
      so_service_priority_priority_id:   { type: 'number',  required: false },
      so_service_priority_price:         { type: 'number',  required: false },
      so_service_priority_deadline_days: { type: 'number',  required: false },
      so_service_priority_order:         { type: 'number',  required: false },
      so_service_color:                  { type: 'string',  required: false },
      so_priority_color:                 { type: 'string',  required: false },
      so_service_priority_franchise_id:  { type: 'number',  required: false },
      so_service_priority_active:        { type: 'number',  required: false },
      so_service_priority_created_at:    { type: 'string',  required: false },
      so_service_priority_service_name:  { type: 'string',  required: false },
      so_service_priority_priority_name: { type: 'string',  required: false },
      so_priority_name:                  { type: 'string',  required: false },
      so_service_name:                   { type: 'string',  required: false },
      so_service_category_id:            { type: 'number',  required: false },
      so_service_category_name:          { type: 'string',  required: false },
      so_service_category_icon_svg:      { type: 'string',  required: false },
      franquia:                          { type: 'string',  required: false },
    },
  },
})
